<template>
  <div class="container border-1">
    <div class="embed-responsive embed-responsive-16by9 mx-auto">
      <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/RRImzkzp4ew?modestbranding=1&autoplay=0&controls=1&fs=0&loop=0&rel=0&showinfo=0&iv_load_policy=3"></iframe>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'brekendnieuws'
    }
</script>

<style>
</style>

